import $ from 'jquery';

export const onTotalChangesSinceLastSaveChange = (
  totalChangesSinceLastSave
) => {
  if (totalChangesSinceLastSave === 0) {
    $('#editor-menu-salva')
      .removeClass('g-btn-warning')
      .removeClass('btn-warning btn-success'); // cleanup legacy
  } else {
    $('#editor-menu-salva')
      .addClass('g-btn-warning')
      .removeClass('btn-success'); // cleanup legacy
  }
};
